
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enable-safari/update-ios",
      function () {
        return require("private-next-pages/enable-safari/update-ios.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enable-safari/update-ios"])
      });
    }
  